import { Injectable, ApplicationRef } from '@angular/core';
import { environment } from 'src/environments/environment';
import { Socket } from 'ngx-socket-io';

@Injectable({
  providedIn: 'root',
})
export class SocketWebService extends Socket {
  // private socket: Socket

  constructor(appRef: ApplicationRef) {
    super(
      {
        url: environment.apiAddressSockets,
        options: {
          path: '/ws/socket.io',
          autoConnect: false,
          reconnection: true,
        },
      },
      // @ts-ignore - Los tipos locales dicen 1 arg, pero Docker espera 2
      appRef
    );
  }

  connectToRoom(botId: string, refreshFunction: () => void) {
    try {
      this.ioSocket.connect();
      this.ioSocket.emit('join', { room: botId });
      this.ioSocket.on('new_message', (msg: any) => {
        if (msg.toUpperCase() === 'refresh'.toUpperCase()) {
          refreshFunction();
        }
      });
    } catch (error) {
      console.error('Error al conectar a la sala:', error);
    }
  }

  disconnectRoom(botId: string) {
    try {
      this.ioSocket.emit('leave', { room: botId });
      this.ioSocket.disconnect();
    } catch (error) {
      console.error('Error al desconectar de la sala:', error);
    }
  }
}
